export default function CheckoutSkeleton() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#ffffff' }}>
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6">
          <div className="h-10 w-32 rounded" style={{ background: 'rgba(0,0,0,0.04)' }} />
        </div>
        <div className="rounded-lg p-6" style={{ background: '#ffffff', border: '1px solid rgba(0,0,0,0.08)' }}>
          <div className="h-5 w-48 rounded mb-2" style={{ background: 'rgba(0,0,0,0.06)' }} />
          <div className="h-3 w-64 rounded mb-6" style={{ background: 'rgba(0,0,0,0.04)' }} />
          <div className="pt-4 mb-6" style={{ borderTop: '1px solid rgba(0,0,0,0.06)' }}>
            <div className="flex justify-between items-center">
              <div className="h-3 w-20 rounded" style={{ background: 'rgba(0,0,0,0.04)' }} />
              <div className="h-5 w-24 rounded" style={{ background: 'rgba(0,0,0,0.06)' }} />
            </div>
          </div>
          <div className="h-11 rounded mb-4" style={{ background: 'rgba(0,0,0,0.04)' }} />
          <div className="h-11 rounded" style={{ background: 'rgba(0,0,0,0.06)' }} />
        </div>
        <div className="mt-4 flex justify-center">
          <div className="h-3 w-48 rounded" style={{ background: 'rgba(0,0,0,0.03)' }} />
        </div>
      </div>
    </div>
  );
}
